import { showCurrency } from '../../utils';

export const formatAmount = (amount, currency) => {
	if (amount === undefined || amount === null) return '';
	const value = new Intl.NumberFormat('es-UY').format(amount);
	return currency ? `${showCurrency(currency) || currency} ${value}` : value;
};

const formatDate = (value) => (value ? String(value).slice(0, 10) : '');

const count = (n, t, key) => (n ? `${n} ${t(key).toLowerCase()}` : '');

// One-line detail under each row, per preview section. Row shapes come from
// services/cascadeGraph.js renderMainEntities (same as the account preview).
const DESCRIBERS = {
	debts: (item, t) => [formatAmount(item.amount, item.currency), formatDate(item.date),
		count(item.dueCount, t, 'entity.due.plural'), count(item.paymentCount, t, 'entity.payment.plural')],
	credits: (item, t) => [formatAmount(item.amount, item.currency), formatDate(item.date),
		count(item.dueCount, t, 'entity.due.plural'), count(item.paymentCount, t, 'entity.payment.plural')],
	contracts: (item, t) => [item.status, formatAmount(item.amount, item.currency),
		count(item.debtCount, t, 'entity.debt.plural'), count(item.creditCount, t, 'entity.credit.plural')],
	assetSales: (item, t) => [formatAmount(item.amount, item.currency), formatDate(item.date),
		count(item.debtCount, t, 'entity.debt.plural')],
	commissions: (item) => [formatAmount(item.amount, item.currency)],
	documents: (item) => [item.documentType],
};

/** Section config entry: `{ key, labelKey, describe }` for a preview section key. */
export const section = (key, labelKey, source) => ({
	key,
	labelKey,
	source,
	describe: DESCRIBERS[key]
		? (item, t) => DESCRIBERS[key](item, t).filter(Boolean).join(' · ')
		: undefined,
});
